<template><div><h1>VUX V2.7.0 发布日志</h1>
<h2><a href="/zh-CN/components/calendar.html">Calendar</a></h2>
<ul><li>[fix] 修复上边框 #2104</li>
</ul>
<h2><a href="/zh-CN/components/cell.html">Cell</a></h2>
<ul><li>[fix] 修复 ssr 渲染问题</li>
</ul>
<h2><a href="/zh-CN/components/checklist.html">Checklist</a></h2>
<ul><li>[fix] 修复默认选中项缺失问题 #2122</li>
</ul>
<h2><a href="/zh-CN/components/datetime.html">Datetime</a></h2>
<ul><li>[fix] 修复服务端渲染多语言 bug</li>
<li>[fix] 修复 readonly 为 true 时点击还会显示弹窗的问题 #2079</li>
</ul>
<h2><a href="/zh-CN/components/flow.html">Flow</a></h2>
<ul><li>[feature] 为 flow-state 添加 slot:title #2010</li>
</ul>
<h2><a href="/zh-CN/components/inline-calendar.html">InlineCalendar</a></h2>
<ul><li>[enhance] 在 created hook 执行渲染而不是 mounted(ssr)</li>
<li>[feature] 添加属性 prop:disable-weekend 来禁用周末 #2105</li>
<li>[feature] 添加属性 prop:disable-date-function 自定义标记禁用日期 #2105</li>
<li>[fix] 移除重复的多次重复渲染 #2066</li>
</ul>
<h2><a href="/zh-CN/components/picker.html">Picker</a></h2>
<ul><li>[change] picker 移动距离不再遵从 html[data-dpr]，需使用 ConfigPlugin 配置 #2082 #1979</li>
</ul>
<h2><a href="/zh-CN/components/popup-picker.html">PopupPicker</a></h2>
<ul><li>[feature] 增加属性 popup-title(使用 popup-header 组件) #1866</li>
</ul>
<h2><a href="/zh-CN/components/popup-radio.html">PopupRadio</a></h2>
<ul><li>[fix] 兼容 vue@2.5.0 scope 更名为 slot-scope 的问题 #2076</li>
</ul>
<h2><a href="/zh-CN/components/qrcode.html">Qrcode</a></h2>
<ul><li>[fix] 修复 value 为 undefined 时报错的问题 #2070</li>
<li>[change] 使用 style 样式设置宽高 #2075</li>
</ul>
<h2><a href="/zh-CN/components/selector.html">Selector</a></h2>
<ul><li>[fix] 兼容服务端渲染</li>
<li>[fix] 修复值为 null 时 placeholder 没有显示的问题 #2101</li>
</ul>
<h2><a href="/zh-CN/components/swiper.html">Swiper</a></h2>
<ul><li>[enhance] 非循环模式下对第一张和最后一张使用更短的拖动距离</li>
<li>[feature] 添加事件 event:on-get-height #2112</li>
<li>[enhance] auto 支持动态设置 #2027</li>
</ul>
<h2><a href="/zh-CN/components/x-address.html">XAddress</a></h2>
<ul><li>[fix] 兼容 vue@2.5.0 scope 更名为 slot-scope 的问题 #2076</li>
<li>[feature] 增加属性 popup-title(使用 popup-header 组件) #1866</li>
</ul>
<h2><a href="/zh-CN/components/x-dialog.html">XDialog</a></h2>
<ul><li>[feature] 添加事件 on-click-mask #2102</li>
</ul>
<h2><a href="/zh-CN/components/x-switch.html">XSwitch</a></h2>
<ul><li>[feature] 支持 prop:value-map 自定义值映射，比如 [0, 1] ["0", "1"] 等接口可能返回的非 boolean 值 #2104</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.7.0 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.7.0-258.vue?17084454